import React from 'react';
import { Bookmark } from 'lucide-react';

export default function BookmarkIcon({ filled, size = 18 }: { filled: boolean; size?: number }) {
  return <Bookmark size={size} fill={filled ? 'currentColor' : 'none'} strokeWidth={2} aria-hidden style={{ flexShrink: 0 }} />;
}
